import { ContactSupport } from "@memorang/ui/components/RedeemCopilot/ContactSupport";
import { AccessContent } from "../components/AccessContent";
import { Purchases } from "../components/Purchases";
import { COPILOT_ACTIONS } from "../constants/actions";

export const COPILOT_ACTION_RENDERERS = {
	[COPILOT_ACTIONS.REDEEM_ACCESS_CODE]: {
		component: AccessContent,
	},
	[COPILOT_ACTIONS.GET_PURCHASES]: {
		component: Purchases,
	},
	[COPILOT_ACTIONS.CONTACT_SUPPORT]: {
		component: ContactSupport,
	},
};
